import React, { ReactElement } from 'react';
import '../assets/overwrite-base.scss';

const Style = (): ReactElement => <></>;

export default Style;
